import { io } from "socket.io-client";

const { rz } = window;

// console.log("host: " + window.location.host);
const socket = io((window.location.protocol === "https:" ? "https://" : "http://") + window.location.host, { autoConnect: false, reconnection: true, transports: ["polling"] }).connect(); // "websocket"

socket.on("connect", () => {
  // rz.log({message: "Socket.io is connected to server with id '" + socket.id + "'", module: "socket.ts", caller: "socket.on('connect')"});
  if (socket.id) {
    socket.emit("subscribe", {room: "any", resetrooms: false});
    // rz.log({message: "socket.emit('subscribe', clientid: '" + socket.id + "', room: 'any')", module: "socket.ts", caller: "socket.on('connect')"});
  }
});

socket.on("disconnect", (reason) => {
  rz.log({message: "Socket.io is disconnected with reason: " + reason, module: "socket.ts", caller: "socket.on('disconnect')"});
});

socket.on("connect_error", (err) => {
  rz.log({message: "Socket.io connection error: " + err, module: "socket.ts", caller: "socket.on('connect_error')"});
  // revert to classic upgrade
  // socket.io.opts.transports = ["polling", "websocket"];
});

export default socket;
